import { render, staticRenderFns } from "./invoice-update.vue?vue&type=template&id=0bb23505&scoped=true&"
import script from "./invoice-update.vue?vue&type=script&lang=js&"
export * from "./invoice-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb23505",
  null
  
)

export default component.exports